import styled from "styled-components";

export const DescriptionList = styled.dl`
	> dt {
		margin-top: ${({ theme }) => theme.spacing(4)};
		font-weight: ${({ theme }) => theme.fonts.weights.bold};
	}
`;
